import React, { useState } from 'react'
import DiscrepancyList from './DiscrepancyList'

interface InspectorDrawerProps {
  trackId: string | null
  onClose: () => void
}

const InspectorDrawer: React.FC<InspectorDrawerProps> = ({ trackId, onClose }) => {
  const [currentPhase, setCurrentPhase] = useState<1 | 2>(1)
  const [crewId, setCrewId] = useState('')
  const [auditType, setAuditType] = useState('')

  // Mock data for demonstration
  const mockDiscrepancies = [
    { railCarId: 'GATX123', type: 'MISSING' as const },
    { railCarId: 'BNSF456', type: 'MISSING' as const },
    { railCarId: 'UP789', type: 'MISSING' as const },
    { railCarId: 'CSX101', type: 'GHOST' as const },
  ]

  const handleNext = () => {
    setCurrentPhase(2)
  }

  const handleBack = () => {
    setCurrentPhase(1)
  }

  const handleSubmit = () => {
    // TODO: Submit audit to backend
    console.log('Submitting audit:', { trackId, crewId, auditType })
    onClose()
  }

  const handleCancel = () => {
    onClose()
  }

  if (currentPhase === 1) {
    return (
      <div className="inspector-drawer">
        <h2>Track 3 - Sweep Audit</h2>
        <div className="discrepancy-summary">
          <div className="summary-item missing">
            <span className="count">3</span>
            <span className="label">Missing</span>
          </div>
          <div className="summary-item ghost">
            <span className="count">1</span>
            <span className="label">Ghost</span>
          </div>
        </div>
        <DiscrepancyList discrepancies={mockDiscrepancies} />
        <div className="drawer-actions">
          <button className="btn-primary" onClick={handleNext}>
            Next
          </button>
          <button className="btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="inspector-drawer">
      <h2>Track 3 - Sweep Audit</h2>
      <div className="audit-form">
        <div className="form-group">
          <label htmlFor="crew">Crew Selection</label>
          <select
            id="crew"
            value={crewId}
            onChange={(e) => setCrewId(e.target.value)}
          >
            <option value="">Select Crew</option>
            <option value="CREW_A">Crew A</option>
            <option value="CREW_B">Crew B</option>
            <option value="Z_TEAM">Z-Team</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="auditType">Audit Type</label>
          <select
            id="auditType"
            value={auditType}
            onChange={(e) => setAuditType(e.target.value)}
          >
            <option value="">Select Audit Type</option>
            <option value="POST_ARRIVAL">Post-Arrival Audit</option>
            <option value="SHIFT_TURNOVER">Shift Turnover</option>
            <option value="SAFETY_SPOT_CHECK">Safety Spot-Check</option>
          </select>
        </div>
      </div>
      <div className="drawer-actions">
        <button className="btn-primary" onClick={handleSubmit}>
          Submit
        </button>
        <button className="btn-secondary" onClick={handleBack}>
          Back
        </button>
        <button className="btn-secondary" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  )
}

export default React.memo(InspectorDrawer)
